import { render } from "./NewOrderModal.vue?vue&type=template&id=627eb5a0&scoped=true"
import script from "./NewOrderModal.vue?vue&type=script&lang=js"
export * from "./NewOrderModal.vue?vue&type=script&lang=js"

import "./NewOrderModal.vue?vue&type=style&index=0&id=627eb5a0&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-627eb5a0"]])

export default __exports__